module.exports = __webpack_public_path__ + "static/media/student-snapshort1-watch.78d81baa.png";